import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { IIdTitle } from "../common/idTitle";
import { WhistleBlowChannelResourceType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

class IndexCache {
    private static indexes: { [name: string]: number } = {};

    static initialize() {
        this.indexes = {};
    }

    static findIndex(id: string, cultures: IIdTitle[]): number {
        let result = this.indexes[id];
        if (Base.isNullOrUndefined(result)) {
            result = cultures.findIndex(i => i.id === id);
            this.indexes[id] = result;
        }
        return result;
    }
}

export interface IWhistleBlowChannelEditResourceItem extends IEditItem {
    resourceType: WhistleBlowChannelResourceType;
    cultureCode: string;
    content: string;
    activeState: number;
    modifyUser: IModifyUser;
}

export class WhistleBlowChannelEditResourceItem extends EditItem implements IWhistleBlowChannelEditResourceItem {
    resourceType: WhistleBlowChannelResourceType;
    cultureCode: string;
    content: string;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IWhistleBlowChannelEditResourceItem);
    constructor(obj?: any) {
        super(obj);
        this.resourceType = obj && obj.resourceType || WhistleBlowChannelResourceType.Text;
        this.cultureCode = obj && obj.cultureCode || "";
        this.content = obj && obj.content || "";
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }

    static sortWhistleBlowChannelEditResourceItems(items: IWhistleBlowChannelEditResourceItem[], cultures: IIdTitle[]): IWhistleBlowChannelEditResourceItem[] {
        if (!items && items.length < 2) return items;
        IndexCache.initialize();
        return items.sort((a: IWhistleBlowChannelEditResourceItem, b: IWhistleBlowChannelEditResourceItem) => {
            const result = (!a || !b) ? 0 : Base.numCompare(a.resourceType, b.resourceType);
            if (result !== 0) return result;
            return (!a || !b) ? 0 : Base.numCompare(IndexCache.findIndex(a.cultureCode, cultures), IndexCache.findIndex(b.cultureCode, cultures));
        });
    }
}

export class WhistleBlowChannelEditResourceItemSave extends EditItem {
    resourceType: WhistleBlowChannelResourceType;
    cultureCode: string;
    content: string;
    activeState: number;

    constructor();
    constructor(obj: IWhistleBlowChannelEditResourceItem);
    constructor(obj?: any) {
        super(obj);
        this.resourceType = obj && obj.resourceType || WhistleBlowChannelResourceType.Text;
        this.cultureCode = obj && obj.cultureCode || "";
        this.content = obj && obj.content || "";
        this.activeState = obj && obj.activeState || 0;
    }
}